export const useShouldValidate = ({ onlyValidateWithError, fieldErrors }) => (onlyValidateWithError ? !!fieldErrors : true);
//# sourceMappingURL=useShouldValidate.js.map